import React, { useCallback, useMemo } from "react";

import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import StatsAPI from "@/src/api/StatsAPI";

import { contentDevicesQuery } from "./contentItem.queries";
import { buildContentDevicesRanked } from "./contentItem.utils";
import RankedQueryCard from "../charts/RankedQueryCard";

import type { JSX } from "react";

import type { GetDevicesUsedByContentResponse } from "@/src/api/StatsAPI.types";

import type { ContentItemPeriodProps } from "./contentItem.types";
import type { ChartSeries, ViewsSeriesKey } from "../charts/charts.types";

function ContentDevicesCard({
  contentId,
  period,
}: ContentItemPeriodProps): JSX.Element {
  const { projectSlug } = useParams<{ projectSlug: string }>();
  const { t } = useTranslation("editor-analytics");

  const seriesList = useMemo(
    (): ChartSeries<ViewsSeriesKey>[] => [
      {
        key: "views",
        label: t("charts.series.views"),
        color: "var(--chart-1)",
      },
    ],
    [t],
  );
  const buildRankedList = useCallback(
    (response: GetDevicesUsedByContentResponse | undefined) =>
      buildContentDevicesRanked(response, (platform) => t(platform)),
    [t],
  );
  const fetchCsv = async (): Promise<BlobPart> =>
    StatsAPI.getDevicesUsedByContent({
      contentId,
      projectSlug,
      startDate: period.startDate,
      endDate: period.endDate,
      isExport: true,
    });

  return (
    <RankedQueryCard
      buildRankedList={buildRankedList}
      csvExport={{ fetchCsv, fileName: "platforms.csv" }}
      query={contentDevicesQuery(projectSlug, contentId, period)}
      seriesList={seriesList}
      title={t("contentItem.charts.devices")}
    />
  );
}

export default ContentDevicesCard;
